import parentScope from '../types';

export const SCOPE = `${parentScope}.drilldown`;
export const DRILL_UP = `${SCOPE}/DRILL_UP`;
export const SELECT_COMPARE_MODE = `${SCOPE}/SELECT_COMPARE_MODE`;
export const RESET_DRILL_DOWN = `${SCOPE}/RESET_DRILL_DOWN`;
